// Categorised gynaecology & obstetrics conditions Dr. Yasmin sees.
// Each item links to the booking form with the condition pre-selected.

export const CONDITION_GROUPS = [
  {
    title: "Pregnancy & maternity",
    blurb: "From first trimester to postpartum.",
    items: [
      "Antenatal & prenatal care",
      "High-risk pregnancy",
      "Gestational diabetes",
      "Pre-eclampsia & pregnancy hypertension",
      "Anaemia in pregnancy",
      "Recurrent miscarriage",
      "Twin & multiple pregnancy",
      "Postpartum care",
      "Postnatal depression support",
    ],
  },
  {
    title: "Fertility & reproductive health",
    blurb: "Trying to conceive, and everything around it.",
    items: [
      "PCOS / PCOD",
      "Female infertility",
      "Male fertility work-up",
      "Ovulation disorders",
      "Endometriosis",
      "Recurrent pregnancy loss",
      "Pre-conception counselling",
      "IUI / IVF guidance",
      "Fibroids affecting fertility",
    ],
  },
  {
    title: "Menstrual & hormonal",
    blurb: "Periods that hurt, disappear or overwhelm.",
    items: [
      "Irregular periods",
      "Heavy or prolonged bleeding",
      "Painful periods (dysmenorrhoea)",
      "Absent periods (amenorrhoea)",
      "PMS & PMDD",
      "Hormonal imbalance",
      "Thyroid & reproduction",
      "Hirsutism / unwanted hair",
    ],
  },
  {
    title: "Gynaecological conditions",
    blurb: "Common concerns, treated with care.",
    items: [
      "Uterine fibroids",
      "Ovarian cysts",
      "Endometrial polyps",
      "Adenomyosis",
      "Pelvic inflammatory disease (PID)",
      "Recurrent vaginal infections",
      "Urinary tract infections",
      "Abnormal Pap smear",
      "Cervical & vulval health",
    ],
  },
  {
    title: "Menopause & midlife",
    blurb: "The transition, made gentle.",
    items: [
      "Perimenopause",
      "Menopause management",
      "Hot flashes & night sweats",
      "Vaginal dryness",
      "Hormone replacement therapy (HRT)",
      "Bone health & osteoporosis",
      "Midlife weight & mood",
    ],
  },
  {
    title: "Adolescent & preventive",
    blurb: "For every stage — including the first.",
    items: [
      "First period concerns",
      "Adolescent gynaecology",
      "Contraception counselling",
      "Cervical cancer screening",
      "HPV vaccination",
      "Breast health check",
      "Well-woman check-ups",
    ],
  },
  {
    title: "Aesthetic gynaecology",
    blurb: "Post-birth and personal wellness.",
    items: [
      "Vaginal rejuvenation",
      "Laser gynaecology",
      "Post-delivery care",
      "Intimate wellness consultation",
    ],
  },
];

// Flat list — for footer chip-cloud
export const ALL_CONDITIONS = CONDITION_GROUPS.flatMap((g) => g.items);
